import { Color } from "../../types";

export enum FlexDirection {
  Row = "row",
  Column = "column",
  RowReverse = "row-reverse",
  ColumnReverse = "column-reverse",
}

export enum JustifyContent {
  Center = "center",
  Start = "flex-start",
  End = "flex-end",
  Between = "space-between",
  Evenly = "space-evenly",
  Around = "space-around",
}

export enum AlignItems {
  Center = "center",
  End = "flex-end",
  Start = "flex-start",
  Baseline = "baseline",
  Initial = "initial",
}

export enum Wrap {
  Wrap = "wrap",
  NoWrap = "nowrap",
}

export interface ContainerLayout {
  justifyContent?: JustifyContent;
  alignItems?: AlignItems;
  flexWrap?: Wrap;
  gap?: number;
}

export interface ContainerCustom {
  background?: Color;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  className?: string;
  props?: React.HTMLAttributes<HTMLDivElement>;
  containerRef?: React.RefObject<HTMLDivElement>;
}

export interface ContainerBaseProps extends ContainerLayout, ContainerCustom {
  flexDirection: FlexDirection;
}

export interface ContainerProps extends ContainerLayout, ContainerCustom {
  reverse?: boolean;
}
